import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Role, RoleFilters, RoleWithUserCount } from '../../shared/models/role';
import { Pagination } from '../../shared/models/page';
import { User } from '../../shared/models/user';
import { Permission } from '../../shared/models/permission';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class RolesService extends BaseService<Role> {
  constructor(protected override http: HttpClient) {
    super(http, 'role');
  }

  getRoles(roleParams: RoleFilters) {
    let params = new HttpParams();

    if (roleParams.sort) {
      params = params.append('sort', roleParams.sort);
    }

    if (roleParams.name) {
      params = params.append('name', roleParams.name);
    }

    params = params.append('pageSize', roleParams.pageSize);
    params = params.append('page', roleParams.page);

    return this.http.get<Pagination<RoleWithUserCount>>(this.baseApiUrl, { params }
    );
  }

  getRole(id: number) {
    return this.http.get<Role>(`${this.baseApiUrl}/${id}`);
  }

  getUsersRole(id: number) {
    return this.http.get<User[]>(`${this.baseApiUrl}/${id}/users`);
  }

  getPermissionsRole(id: number) {
    return this.http.get<Permission[]>(`${this.baseApiUrl}/${id}/permissions`);
  }
}
